<template>
    <tr>
        <td class="dateTime">
            {{ dateApproved }}
        </td>
        <td class="person-name">
            {{ item.responsible.name }}
        </td>
        <td>
            <div class="comment-wrapper">
                {{ item.comments }}
            </div>
        </td>
        <td class="file-download">
            <span v-if="hasFiles">
                <v-icon style="transform: scaleX(-1);">fa-paperclip</v-icon> {{ countFiles }}</span>
        </td>
        <td class="event-type">
            <v-icon v-if="isApprovalOrRejectionStatus" small :class="color">{{ icon }}</v-icon>
        </td>
    </tr>
</template>

<script>
import { dateToLongString } from '@/helpers/filters';
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        icon() {
            return this.isApproval ? 'done' : 'clear';
        },
        color() {
            return this.isApproval ? 'green--text' : 'red--text';
        },
        dateApproved() {
            return dateToLongString(this.item.dateApproved);
        },

        isApproval() {
            return this.item.event.id === constants.EVENT_APPROVED;
        },
        isApprovalOrRejectionStatus() {
            return utilities.isApprovalOrRejectionStatus(this.item.status.id);
        },

        hasFiles() {
            return this.isApprovalOrRejectionStatus && !utilities.isEmptyOrZero(this.item.files);
        },
        countFiles() {
            return this.hasFiles ? this.item.files.length : 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/demands/shared/WorkflowItem.vue